import { StyledOption, StyledSkeletonOption } from "./index.styled";

export { StyledSkeletonOption as SkeletonOption };
export default StyledOption;
